export const OFFLINE_WRITE_MESSAGE =
  "Internet connection is required to save changes.";

export function assertOnline(): void {
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    throw new Error(OFFLINE_WRITE_MESSAGE);
  }
}
